module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex-grid control-ie",
    class: {
      'flex-grid--reduced-bottom-margin': _vm.tableControl || _vm.noFlexMargin
    }
  }, [(!_vm.tableControl) ? _c('div', {
    staticClass: "flex-grid__g-2 flex-grid--input-label"
  }, [_c('label', {
    attrs: {
      "for": _vm.name
    }
  }, [_c('p', {
    class: {
      'u-vertical-centre-transform-desktop no-margin-desktop': _vm.verticalCentre
    }
  }, [_vm._v(_vm._s(_vm.label)), (_vm.isRequired) ? _c('span', {
    staticClass: "flex-grid--input-label-required"
  }, [_vm._v(" *")]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (!_vm.tableControl) ? _c('div', {
    staticClass: "flex-grid__g-7 a-form-inputs",
    class: ['a-form-inputs--' + _vm.beforeAfter, {
      'u-no-margin': !_vm.iconSpace
    }]
  }, [_vm._t("default")], 2) : _c('div', {
    staticClass: "flex-grid__g-9 a-form-inputs",
    class: ['a-form-inputs--' + _vm.beforeAfter, {
      'u-no-margin': !_vm.iconSpace || _vm.theCurrentWidth < 1024
    }]
  }, [_vm._t("default")], 2), _vm._v(" "), (_vm.iconSpace || _vm.theCurrentWidth < 1024) ? _c('div', [(_vm.tipShow) ? _c('div', {
    on: {
      "click": _vm.toggleModal
    }
  }, [_c('icon-tooltip', {
    attrs: {
      "tooltip-name": _vm.tipName,
      "tooltip-text": _vm.tipText,
      "side": _vm.tipSide,
      "text-width": _vm.tipWidth,
      "icon-type": _vm.tipIcon
    }
  })], 1) : _c('div', {
    style: ({
      width: '26px'
    })
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-49198514!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/form/Control.vue
// module id = 1674
// module chunks = 0